import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import useIsAdmin from '../hooks/useIsAdmin';
import Loading from './Loading';

// Shows its children only to an admin. Everyone else goes to the home page.
// Wrap the page in <Suspense> inside this, so the admin code is not even
// downloaded until the check passes.
const RequireAdmin = ({ children }) => {
  const isAdmin = useIsAdmin();

  if (isAdmin === null) return <Loading />;
  if (!isAdmin) return <Redirect to="/" />;
  return children;
};

RequireAdmin.propTypes = {
  children: PropTypes.node
};

export default RequireAdmin;
